import { useString as s } from "../../../../../components/StringProvider";
import { ReactComponent as Icon } from "../../../../../assets/editor/text-right.svg";
import ToolbarButton from "./ToolbarButton";

const RightAlignButton = ({ onClick, active }) => {
  return (
    <ToolbarButton
      active={active}
      onClick={onClick}
      label={s("editor.buttons.right.label", "Right Align")}
    >
      <Icon />
    </ToolbarButton>
  );
};

export default RightAlignButton;
